import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';

/**
 * Contextual help button — a small "?" icon that deep-links into the in-app
 * User Guide at the section most relevant to the current page.
 *
 * @param {string} section - slug of the guide H2 to jump to
 *                           (e.g. "4-the-portfolio-view"). Omit for the top.
 * @param {string} label   - accessible label / tooltip text.
 */
export default function PageHelpButton({ section = '', label = 'Open the user guide for this page', className = '', testId }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(`/user-guide${section ? `#${section}` : ''}`)}
      title={label}
      aria-label={label}
      data-testid={testId || `page-help-${section || 'guide'}`}
      className={`inline-flex items-center justify-center w-7 h-7 rounded-md text-slate-400 hover:text-[#4ABFCF] hover:bg-[#4ABFCF]/10 transition-colors ${className}`}
    >
      <HelpCircle className="w-4 h-4" />
    </button>
  );
}
